import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('packageTotalValue', packageTotalValue);

function packageTotalValue(splitService) {
  return function packageSpotsFilter(packageRef, enableUnitDisplay) {
    let packagesTotalValue;
    const currencyCode = splitService.getCurrencyCode();
    const isPackageTotalValue = splitService.isOmsPackageTotalValue();

    if (packageRef  && packageRef.items?.length) {
      packagesTotalValue = packageRef.items.reduce((res, item) => {
        if (item.value) {
          res += (isPackageTotalValue ? item.value : (item.value * (item.count || 1)));
        }
        return res;
      }, 0);
    }

    const displayValue = packagesTotalValue.toLocaleString(undefined, {maximumFractionDigits: 2})
    return `${displayValue} ${enableUnitDisplay ? currencyCode : ''}`;
  }
}
